/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import './style/bluemateSetupCard.scss';

import React from 'react';

import {Icon} from '@iconify/react';

import {IconifyIcon} from '@iconify/types';

import arrowRight from '@iconify/icons-feather/arrow-right';

import check from '@iconify/icons-feather/check';

import checkCircle from '@iconify/icons-feather/check-circle';

import classNames from 'classnames';

import {useTranslation} from 'react-i18next';

import {nonBreakingHyphens} from '../../../util/utils';

interface Props {
    title: string;
    subtitle: string;
    icon: IconifyIcon;
    completed?: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
    className?: string;
}

export default function BluemateSetupCard(props: Props) {
    const {title, subtitle, icon, completed = false, onClick, onCheckClick, className} = props;
    const {t} = useTranslation();

    function renderBadge() {
        if (completed)
            return (
                <span className='setup-card-badge completed'>
                    <span className='setup-card-badge-core'>
                        <Icon icon={check} />
                    </span>
                </span>
            );
        return (
            <span className='setup-card-badge'>
                <Icon icon={icon} className='setup-card-icon' />
            </span>
        );
    }

    function renderCheckButton() {
        const label = t('controls.setupCard.markComplete', 'Markeer als afgerond');
        return (
            <button type='button' className='setup-card-check' onClick={onCheckClick} aria-label={label} title={label}>
                <Icon icon={checkCircle} />
            </button>
        );
    }

    return (
        <div className={classNames('bluemate-setup-card', completed && 'completed', className)}>
            {!completed && renderCheckButton()}
            <button type='button' className='setup-card-main' onClick={onClick}>
                {renderBadge()}
                <span className='setup-card-content'>
                    <span className='setup-card-title'>{nonBreakingHyphens(title)}</span>
                    <span className='setup-card-subtitle'>{nonBreakingHyphens(subtitle)}</span>
                </span>
                {!completed && <Icon icon={arrowRight} className='setup-card-arrow' />}
            </button>
        </div>
    );
}
